import { apiSlice } from "./apiSlice";

export const bonusApiSlice = apiSlice.injectEndpoints({
  tagTypes: ["BonusDetails", "BonusList", "ClaimBonus", "PromotionRecord"],
  endpoints: (builder) => ({
    getBonusDetails: builder.query({
      query: (bonusCode) => `/bonus/api/v1/bonusDetails/${bonusCode}`,
      providesTags: ["BonusDetails"],
    }),
    getBonusList: builder.query({
      query: (category) => `/bonus/api/v1/bonusList?category=${category}`,
      providesTags: ["BonusList"],
    }),
    getBonusListPromoCenter: builder.query({
      query: (category) => `/bonus/api/v1/bonusListPromoCenter?category=${category}`,
      providesTags: ["BonusListPromoCenter"],
    }),
    claimBonus: builder.mutation({
      query: (bonusCode) => ({
        url: "/bonus/api/v1/claimBonus",
        method: "POST",
        body: bonusCode,
      }),
      providesTags: ["ClaimBonus"],
      invalidatesTags: ["BonusList", "Profile"],
    }),
    redeemCode: builder.mutation({
      query: (body) => ({
        url: "/promo/api/v1/redeem",
        method: "POST",
        body: body,
      }),
      // BonusListPromoCenter (not BonusList) is the tag this page actually subscribes to,
      // and Profile is what the header balance reads.
      invalidatesTags: ["BonusListPromoCenter", "Profile"],
    }),
    getPromotionRecord: builder.mutation({
      query: (queryBody) => ({
        url: "/bonus/api/v1/history",
        method: "POST",
        body: queryBody,
      }),
      providesTags: ["PromotionRecord"],
    }),
  }),
});

export const {
  useLazyGetBonusDetailsQuery,
  useLazyGetBonusListQuery,
  useLazyGetBonusListPromoCenterQuery,
  useClaimBonusMutation,
  useRedeemCodeMutation,
  useGetPromotionRecordMutation,
} = bonusApiSlice;
